import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Route } from 'vue-router'
import { PermissionModule } from '@/store/modules/permission'
import store from './store'
import {
  getRole,
  getUsername,
  getuserCurrentApp,
  getToken,
  setuserCurrentApp
} from './utils/cookies'
import { UserModule } from '@/store/modules/user'
import { getAppid } from './utils/utils'
import app from '@/App.vue'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/404']

function getSsoRedirectToken(variable: string) {
  const currentUrl = window.location.href

  let arr = currentUrl.split('?')
  if (arr.length > 1) {
    arr = arr[1].split('&')
    for (let i = 0; i < arr.length; i++) {
      const tem = arr[i].split('=')
      if (tem[0] === variable) {
        return tem[1]
      }
    }
    return null
  } else {
    return null
  }
}

function getQueryVariable(variable: string, show_raw: boolean) {
  // const query = window.location.search.substring(1)
  const queryIndex = window.location.hash.indexOf('?')
  const query =
    queryIndex === -1 ? '' : window.location.hash.substring(queryIndex + 1)
  const vars = query.split('&')
  if (show_raw) {
    return JSON.stringify(vars)
  }
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return ''
}

async function getPermissionMenu(to: Route, from: Route, next: any) {
  // 首次访问-根据角色匹配菜单
  if (PermissionModule.firstAddFlag) {
    PermissionModule.GenerateRoutes()
    // Dynamically add accessible routes
    router.addRoutes(PermissionModule.dynamicRoutes)
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    nextHandler(to, from, next, true)
  } else {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    nextHandler(to, from, next, false)
  }
}

function nextHandler(
  to: Route,
  from: Route,
  next: any,
  afterAddRoutes?: boolean
) {
  const redirectHash = decodeURIComponent(getQueryVariable('redirect', false))
  if (
    !redirectHash ||
    redirectHash.indexOf(to.path) !== -1 ||
    from.path === redirectHash ||
    whiteList.indexOf(to.path) !== -1
  ) {
    // check current user has dashboard router
    const dashArr = PermissionModule.dynamicRoutes.filter((item) => {
      return item.path === '/dashboard'
    })
    const rawParam = getQueryVariable('', true)
    const raw = JSON.parse(rawParam)
    const rawAppIdData = raw.filter((item: any) => {
      return item.indexOf('appid') !== -1
    })
    const isWebview = rawAppIdData.length <= 0
    const _to = dashArr.length > 0 && isWebview ? dashArr[0] : to

    // Hack: ensure addRoutes is complete
    // Set the replace: true, so the navigation will not leave a history record
    afterAddRoutes ? next({ ..._to, replace: true }) : next()
  } else {
    if (redirectHash === '/') {
      afterAddRoutes ? next({ ...to, replace: true }) : next()
    } else {
      // 跳转到redirect
      next(redirectHash)
    }
  }
}

function getUrlAllParams() {
  const href = decodeURIComponent(window.location.href)
  console.log('href', href)
  if (href.indexOf('redirect=') === -1) {
    let query = window.location.hash.split("?")[1];
    const conPath = window.location.hash.split("?")[0].slice(1);
    let queryObj: any = {};
    console.log('query====>>>' , query)
    if (query) {
      query.split("&").forEach((item) => {
        let arr = item.split("=");
        queryObj[arr[0]] = arr[1];
      });
    }
    const appid = getuserCurrentApp() || queryObj.appid
    console.log('appid is --->>>>' , appid)
    console.log('query is --->>>>' , query)
    console.log('conPath is --->>>>' , conPath)
    console.log('queryObj is --->>>>' , queryObj)
    console.log('queryObj get  is --->>>>' , queryObj.appid)
    if (appid) {
      // 说明从内部工单登录进来
      console.log('说明从内部工单登录进来',conPath + '?' +query)
      return { flag: false, path: 'jump' }
    } else {
      // 正常登录进来  但是没有id参数  --  保障工单
      return { flag: false, path: null, query: null }
    }
  }

  if (href.indexOf('appid') === -1 && href.indexOf('appName') === -1) {
    return { flag: false, path: null, query: null }
  }
  const arr = href.split('redirect=')
  let p: any = 0
  if (arr.length > 1) {
    p = arr[1].split('?')
  } else {
    UserModule.LogOut()
  }
  const queryParams: any = {}
  let path = ''
  if (p.length > 0) {
    path = p[0]
    const query = p[1].split('#')[0].split('&')
    if (query.length > 0) {
      for (let i = 0; i < query.length; i++) {
        const temp = query[i].split('=')
        queryParams[temp[0]] = decodeURIComponent(temp[1])
      }
    }
    return { flag: true, path: path, query: queryParams }
  }
  return { flag: false, path: path, query: queryParams }
}

function autoJumper(next: any) {
  const { flag, path, query } = getUrlAllParams()
  console.log(flag)
  if (flag) {
    console.log('replace to param', path, query)
    if (PermissionModule.firstRedirectFlag) {
      next()
    } else {
      PermissionModule.setFirstRedirectFlag(true)
      next({ path: path, query: query, replace: true })
    }
  } else {
    console.log('11112222 ====>>>> replace createIndex')
    // next({ path: '/jumper', replace: true, query })
    next({ path: '/createIndex', replace: true, query })
  }
}

router.beforeEach(async (to: Route, from: Route, next: any) => {
  if (whiteList.indexOf(to.path) !== -1) {
    // In the free whitelist, go directly
    next()
  } else {
    const queryToken = getSsoRedirectToken('token')
    const appid = getuserCurrentApp()
    if (queryToken && !getUsername()) {
      console.log('to verifyToken')
      store
        .dispatch('verifyToken', {
          token: queryToken,
          appid: appid
        })
        .then(async () => {
          // 1.登录后没有参数，直接进入主页选择界面
          // 2.登录后有参数，来自于群消息跳转
          autoJumper(next)
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {})
    } else {
      if (to.path === '/jumper' && getUsername()) {
        next()
      } else if (to.path === '/createIndex' && getUsername()) {
        next()
      } else if (getRole() && getuserCurrentApp()) {
        getPermissionMenu(to, from, next)
      } else if (!getRole() && !getuserCurrentApp() && getUsername()) {
        // 用户在jumper页面没有选择 || 在未选择的时候进行了页面刷新
        autoJumper(next)
      } else if (!getRole() && getuserCurrentApp() && getUsername()) {
        autoJumper(next)
      } else {
        console.log('我走到了这里====>>>>',to.path)
        next()
        console.log('我走到了这里1111====>>>>',to.path)

        // autoJumper(next)
      }
    }
  }
})

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done()
})
